<div class="relative flex items-center gap-1.5">
  <!-- Watchlist Button -->
  <div class="relative">
    <a routerLink="/profile/watchlist"
      class="watchlist-button group relative flex h-11 w-11 items-center justify-center rounded-full text-gray-600 transition-colors hover:bg-gray-100 hover:text-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500"
      [attr.aria-label]="'Lista życzeń' | translate" [title]="'Lista życzeń' | translate">
      <!-- Heart/Watchlist SVG Icon -->
      <svg class="h-[22px] w-[22px] transition-colors group-hover:text-orange-600" fill="none" stroke="currentColor"
        stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>

      <!-- Watchlist Count Badge -->
      <span *ngIf="watchlistCount > 0"
        class="absolute right-0.5 top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full border-2 border-white bg-orange-500 px-1 text-[10px] font-semibold leading-none text-white"
        aria-live="polite">
        {{ watchlistCount > 99 ? '99+' : watchlistCount }}
      </span>
    </a>
  </div>

  <!-- Auth Button -->
  <div class="relative">
    <button (click)="toggleAuthDropdown(); $event.stopPropagation()"
      class="auth-button group relative flex h-11 w-11 items-center justify-center rounded-full text-gray-600 transition-colors hover:bg-gray-100 hover:text-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500"
      [ngClass]="{ 'bg-gray-100': isAuthDropdownOpen }" [attr.aria-label]="'Menu konta' | translate"
      [attr.aria-expanded]="isAuthDropdownOpen">
      <!-- Modern User Profile SVG Icon (Show when not logged in) -->
      <svg *ngIf="!currentUser" class="h-[22px] w-[22px] transition-colors group-hover:text-orange-600"
        [class.text-orange-600]="isAuthDropdownOpen" [class.text-gray-600]="!isAuthDropdownOpen"
        fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>

      <!-- User Initials Circle (Show when logged in) -->
      <span *ngIf="currentUser"
           class="flex h-9 w-9 items-center justify-center rounded-full border border-orange-100 bg-orange-50 text-xs font-semibold text-orange-700 notranslate"
           translate="no">
        {{ getInitials() }}
      </span>

      <!-- Logged-in Status Indicator Dot -->
      <span *ngIf="currentUser"
            class="absolute bottom-0.5 right-0.5 z-10 h-2.5 w-2.5 rounded-full border-2 border-white bg-emerald-500"
            [attr.aria-label]="'Zalogowano' | translate">
      </span>
    </button>

    <!-- Auth Dropdown -->
    <app-auth-dropdown [isOpen]="isAuthDropdownOpen" (close)="closeAuthDropdown()"></app-auth-dropdown>
  </div>
</div>